import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { sanitizeReferenceFilters } from "../../../util/parseInvoiceReference";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";
import { withExportedItemFilter } from "./InvoiceSearch/exportedItemFilter";

// `unpaid` is a UI-only three-state toggle that drives the
// `balanceAmount` HAVING filter; the invoices table has no `unpaid`
// column so it must not reach the server query.
// `exported` is similar: a UI-only three-state toggle that drives
// the `_item.exported` include filter, since `exported` lives on
// `Item`, not `Invoice`.
const filterKeys = ["tab", "unpaid", "exported"];

const skipKeys = ["limit", "offset"];

// `companies` scopes a prefixed Invoice # / Proforma # (e.g. "WCA123456")
// to the company with that invoice code; without them only the prefix is
// stripped.
const toInvoiceFilter = (values, companies = []) =>
  withExportedItemFilter(
    sanitizeReferenceFilters(
      convertToFilter({ values, filterKeys, skipKeys }),
      companies,
    ),
    values?.exported,
  );

// observable store
const invoiceFilterStore = makeObservable({});
const invoiceNavigationStore =
  createSearchResultNavigationStore(invoiceFilterStore);
const filterFormStore = createFilterFormStore(
  "invoice",
  invoiceFilterStore,
  invoiceNavigationStore,
  { toFilter: toInvoiceFilter },
);

const useInvoiceFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        contactId: { operator: "eq" },
        limit: 50,
        offset: 0,
        tab: "invoice",
        sort1: { operator: "ASC" },
        sort2: { operator: "ASC" },
        sort3: { operator: "ASC" },
        companyId: { operator: "in" },
        _CRMRegistrar: { typeId: { operator: "in" } },
        _condition: { statusId: { operator: "in" } },
        _item: {
          typeId: { operator: "in" },
          _instance: {
            _edition: {
              _artwork: {
                categoryId: { operator: "in" },
                _artist: {
                  id: { operator: "in" },
                },
              },
            },
          },
        },
        _invoiceSalesPerson: {
          split: { operator: "eq" },
        },
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    // convert formik values to filter and update store
    invoiceFilterStore.set(toInvoiceFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export {
  invoiceFilterStore,
  invoiceNavigationStore,
  toInvoiceFilter,
  useInvoiceFilters,
};
